import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { CgWebsite } from "react-icons/cg";
import { BsGithub } from "react-icons/bs";

const ProjectCards = (props) => {
  return (
    <Card className="project-card-view">
      <Card.Img variant="top" src={props.imgPath} alt="card-img" />
      <Card.Body>
        <Card.Title>{props.title}</Card.Title>
        <Card.Text style={{ textAlign: "justify" }}>
          {props.description}
        </Card.Text>
      </Card.Body>
      <Card.Footer
        style={{ display: "flex", justifyContent: "space-between" }}
      >
        <div>
          <Button
            variant="primary"
            href={props.ghLink}
            target="_blank"
            style={{ minWidth: "120px" }}
          >
            <BsGithub /> &nbsp; {props.isBlog ? "Blog" : "GitHub"}
          </Button>
        </div>
        {!props.isBlog && props.demoLink && (
          <div>
            <Button
              variant="primary"
              href={props.demoLink}
              target="_blank"
              style={{ minWidth: "120px" }}
            >
              <CgWebsite /> &nbsp; Demo
            </Button>
          </div>
        )}
      </Card.Footer>
    </Card>
  );
};

export default ProjectCards;
